<template>
    <div class="box">
        <div class="news">
            <div class="newsleft">
                <div class="leftpic">
                    <img
                            src="../../static/Policies _regulations.png"
                            style="height: 80px;"
                    />
                </div>
                <div class="leftpic1">
                    <img
                            src="../../static/line.png"
                            style="width: 100%; height: 100%"
                    />
                </div>
                <div class="leftTitle">公示公告</div>
                <div class="tabs">
                    <div @click="tabChange(item)" v-for="item in classList" :key="item.dictCode">
                        <p :class="{ active: tabIndex == item.dictSort }">{{item.dictLabel}}</p>
                        <div class="line" v-if="tabIndex == item.dictSort"></div>
                    </div>
                </div>
                <div class="jia">
                    <img
                            src="../../static/jia.png"
                            style="width: 100%; height: 100%"
                    />
                </div>
            </div>
            <div class="newsright">
              <dataNone v-if="countList.length<=0"></dataNone>
             <ul class="UL">
                 <li class="li" v-for="item in countList" :key="item.id" @click="jumpDet(item)">
                   <div style="display: flex;align-items: center;">
                       <div class="circle"></div>
                       <div class="text" v-html="item.title">
                       </div>

                   </div>
                     <div class="time">{{item.createTime}}</div>
                 </li>
             </ul>
            </div>
        </div>
    </div>
</template>

<script>
import {htmlSplice} from "../../../utils/common";
import dataNone from "@/components/dataNone.vue";
export default {
  name: 'policiesRegulations',
  components: {
      dataNone
  },
  data() {
        return {
            tabIndex: 0,
            classList:[],
            countList:[],
            dictSort:'',
            queryParams:{
                pageSize: 10,
                pageNum: 1,
                classify:""
            }
        }
    },
    created(){
        this.getClassList()
    },
    methods: {
      // 跳转文章列表
      jumpList() {
        this.$router.push({ path: "/newsCenter", query: {
            type: 'gkgs',
            tabInd: 6
          } });
      },
      // 跳转文章详情
      jumpDet(v) {
        this.$router.push({ path: "/articleDet", query: {
            pageType: 'gkgs',
            pageName: this.classList[this.tabIndex - 1].dictLabel,
            ...v
          } });
      },
        tabChange(row) {
            console.log(row)
            this.tabIndex = row.dictSort
            this.getcountList(row.dictSort)
        },
        getClassList(){
            this.$api.getAnnouncementClassifyApi().then(res=>{
                this.classList=res.data
                this.tabIndex=res.data[0].dictSort
                this.getcountList(res.data[0].dictSort?res.data[0].dictSort:0)
            })
        },
        getcountList(dictSort){
            this.queryParams.classify=dictSort
            this.$api.getAnnouncementApi(this.queryParams).then((res) => {
                // this.list = res.rows;
                console.log(res.rows)
                this.countList=res.rows
                if (this.countList.length != 0) {
                  this.countList.forEach(item => {
                    item.createTime = item.createTime.split(' ')[0]
                  })
                }
            });
        },
    },
}
</script>

<style scoped lang="less">
.active {
  font-weight: 600;
  font-size: 1.25rem /* 20/16 */;
  color: #1e439b;
}
.box {
    min-width: 93.75rem /* 1500/16 */;
    background-color: #fff;
    margin: 0 auto;
}
.news {
    height: 100%;
    display: flex;
    box-sizing: border-box;
    padding: 100px 6.5rem;
    width: 93.75rem /* 1500/16 */;
    margin: 0 auto;
    min-width: 93.75rem /* 1500/16 */;

  .newsleft {
    margin-right: 6.25rem /* 100/16 */ /* 130/16 */;

    .leftpic {
      width: 17.6875rem /* 283/16 */;
      height: 5.9375rem /* 95/16 */;
      // margin-bottom: 30px;
    }

    .leftpic1 {
      width: 5.5625rem /* 89/16 */;
      margin-top: 1.9375rem /* 31/16 */;
      margin-bottom: 3.75rem /* 60/16 */;
    }

    .leftTitle {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: bold;
      font-size: 2.1875rem /* 35/16 */;
      color: #333333;
      line-height: 0rem /* 0/16 */;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    .tabs {
      margin-top: 9.625rem /* 154/16 */;
      margin-bottom: 8.6875rem /* 139/16 */;
    }
    .line {
      width: 5rem /* 80/16 */;
      height: 0.125rem /* 2/16 */;
      background: #1e439b;
      border-radius: 0px 0px 0px 0px;
    }
    .tabs div {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 1.25rem /* 20/16 */;
      color: #333333;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-bottom: 2.375rem /* 38/16 */;
      cursor: pointer;
    }
    .jia {
      width: 3.125rem /* 50/16 */;
      height: 3.125rem /* 50/16 */;
      cursor: pointer;
    }
  }

  .newsright {
    width: 100%;
    padding-top: 7.5rem /* 120/16 */;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    .UL{
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
    }
    .li{
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px;
      width: 430px;
      line-height: 35px;
      border-bottom: 1px solid #EEEEEE;
      margin-bottom: 50px;
      .circle{
        width: 5px;
        height: 5px;
        background-color: #000;
        border-radius: 50%;
        margin-right: 15px;
      }
      .text{
        font-size: 18px;
        color: #333333;
          width: 265px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
      }
      .time{
        font-size: 18px;
        color: #333333;
      }
    }

  }
}
</style>
